// extracted by mini-css-extract-plugin
module.exports = {"versionTable":"style_versionTable__2_wpC1TowkXhJ-s4IV-QOt"};